import { collateErrors as collateNewPasswordErrors } from '@ynap/password-input'

export default function collateErrors(values, props, json) {
    let errors = {}
    const { messages, form, change } = props

    const passwordErrors = collateNewPasswordErrors(values, props, json)

    if (json && json.errors) {
        json.errors.forEach(({ errorParameters, errorKey, errorMessage }) => {
            switch (errorKey) {
                case 'ERR_AUTHENTICATION_ERROR':
                    errors.x_logonPasswordCurrent = messages.errors.authenticationError()
                    break
                case '_ERR_AUTHENTICATION_REUSEOLD_PASSWORD':
                    errors.logonPassword = messages.errors.reuseOldPassword()
                    break
                case '_ERR_AUTHENTICATION_USERIDMATCH_PASSWORD':
                    errors.logonPassword = messages.errors.containsLogonId()
                    break
                case '_ERR_AUTHENTICATION_MAXINTANCECHAR_PASSWORD':
                case '_ERR_AUTHENTICATION_MAXCONSECUTIVECHAR_PASSWORD':
                case '_ERR_AUTHENTICATION_MINIMUMLENGTH_PASSWORD':
                case '_ERR_AUTHENTICATION_MINIMUMDIGITS_PASSWORD':
                case '_ERR_AUTHENTICATION_MINIMUMLETTERS_PASSWORD':
                case 'ERR_AUTHENTICATION_BLACKLISTED_PASSWORD':
                case 'ERR_AUTHENTICATION_WHITESPACE_IN_PASSWORD':
                case 'ERR_AUTHENTICATION_GUESSABLE_PASSWORD':
                case 'ERR_INSUFFICIENT_STRENGTH_PASSWORD':
                    errors._error = messages.errors.meetRequirements()
                    break
                case 'ERR_MY_DETAILS_NOT_ALLOWED_TO_UPDATE': {
                    const timeToWaitInHours = Math.round(errorParameters / 3600)
                    errors._error = messages.errors.updateNotAllowed({ timeToWait: timeToWaitInHours })
                    break
                }
                default:
                    errors._error = messages.errors.generic()
            }
        })
        return errors
    }

    const _error =
        !Object.keys(errors).length && !Object.keys(passwordErrors).length ? messages.errors.global() : undefined

    return { _error, ...errors, ...passwordErrors }
}
